import L from "leaflet";

/** Các icon tùy chọn (admin + bản đồ) — mỗi key một hình khác nhau */
export const MAP_ICON_OPTIONS = [
  { value: "all", label: "Tự động theo danh mục" },
  { value: "culture", label: "Văn hoá — pin & đền" },
  { value: "food", label: "Ăn uống — tròn & dao dĩa" },
  { value: "stay", label: "Lưu trú — viên & nhà" },
  { value: "church", label: "Nhà thờ / tôn giáo" },
  { value: "temple", label: "Chùa / di tích" },
  { value: "flower", label: "Làng hoa / vườn" },
  { value: "coffee", label: "Cà phê / quán" },
  { value: "market", label: "Chợ / mua sắm" },
  { value: "lake", label: "Hồ / thác / nước" },
  { value: "park", label: "Công viên / rừng" },
  { value: "hotel", label: "Khách sạn / resort" },
  { value: "viewpoint", label: "View / săn mây" },
  { value: "farm", label: "Trang trại / vườn" },
  { value: "night", label: "Chợ đêm / bar" },
  { value: "camera", label: "Check-in / sống ảo" },
  { value: "museum", label: "Bảo tàng / triển lãm" },
  { value: "bridge", label: "Cầu / công trình" },
  { value: "camping", label: "Cắm trại / dã ngoại" },
];

const EXTENDED = new Set(MAP_ICON_OPTIONS.map((o) => o.value));

function markerKindFromCategory(category, categorySlug) {
  if (category === "food" || categorySlug === "am-thuc-local") return "food";
  if (category === "stay" || categorySlug === "homestay-khach-san") return "stay";
  if (category === "culture" || categorySlug === "du-lich-van-hoa") return "culture";
  return "default";
}

/**
 * mapIcon từ API (chuỗi) — nếu "all" hoặc không có thì theo danh mục.
 */
export function resolveMarkerVisualKey(mapIcon, category, categorySlug) {
  const raw = mapIcon == null || mapIcon === ""
    ? "all"
    : String(mapIcon).toLowerCase().trim().replace(/\s+/g, "-");
  if (raw && raw !== "all" && EXTENDED.has(raw)) return raw;
  return markerKindFromCategory(category, categorySlug);
}

function shadow(tileStyle) {
  return tileStyle === "satellite"
    ? "0 6px 22px rgba(0,0,0,0.55)"
    : "0 4px 16px rgba(0,0,0,0.18)";
}

function bw(tileStyle) {
  return tileStyle === "satellite" ? 3 : 2.5;
}

function drop(tileStyle, strong) {
  if (tileStyle === "satellite") {
    return strong
      ? "drop-shadow(0 5px 14px rgba(0,0,0,0.6))"
      : "drop-shadow(0 4px 10px rgba(0,0,0,0.35))";
  }
  return strong
    ? "drop-shadow(0 4px 12px rgba(0,0,0,0.3))"
    : "drop-shadow(0 4px 10px rgba(0,0,0,0.28))";
}

/** Pin giọt — văn hoá */
function specCulture(B, S) {
  const D = drop(S, true);
  return {
    html: `
    <div style="width:40px;height:48px;pointer-events:none;filter:${D};">
      <svg width="40" height="48" viewBox="0 0 40 48" style="display:block;">
        <path fill="#ea580c" stroke="#fff" stroke-width="${B}"
          d="M20 3C11.8 3 5 9.4 5 17.2c0 6.2 4.5 12.8 15 27.5 10.5-14.7 15-21.3 15-27.5C35 9.4 28.2 3 20 3z"/>
        <circle cx="20" cy="17" r="9" fill="#fff7ed"/>
        <g fill="none" stroke="#9a3412" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14 20h12M14 20V11M18 11V8M22 11V8M26 20V11M14 11h12"/>
          <path d="M17 8l3-2.2 3 2.2"/>
        </g>
      </svg>
    </div>`,
    size: [40, 48],
    anchor: [20, 48],
    popup: [0, -46],
  };
}

function specFood(B, S) {
  const sh = shadow(S);
  return {
    html: `
    <div style="width:44px;height:44px;border-radius:50%;background:linear-gradient(145deg,#fb7185,#e11d48);
      border:${B}px solid #fff;box-shadow:${sh};display:flex;align-items:center;justify-content:center;">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M3 2v7c0 1.6 1.3 3 3 3h4c1.6 0 3-1.4 3-3V2"/>
        <path d="M7 2v20"/>
        <path d="M21 15V8a4 4 0 0 0-4-4h-1v11"/>
        <path d="M21 15v6"/>
      </svg>
    </div>`,
    size: [44, 44],
    anchor: [22, 40],
    popup: [0, -36],
  };
}

function specStay(B, S) {
  const sh = shadow(S);
  return {
    html: `
    <div style="width:48px;height:36px;border-radius:12px;background:linear-gradient(180deg,#22d3ee,#0891b2);
      border:${B}px solid #fff;box-shadow:${sh};display:flex;align-items:center;justify-content:center;">
      <svg width="26" height="22" viewBox="0 0 24 22" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M3 10.5L12 3l9 7.5V19a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-8.5z"/>
        <path d="M9 21v-6h6v6"/>
      </svg>
    </div>`,
    size: [48, 36],
    anchor: [24, 34],
    popup: [0, -32],
  };
}

function specDefault(B, S) {
  const sh = shadow(S);
  return {
    html: `
    <div style="width:34px;height:34px;background:#64748b;border:${B}px solid #fff;border-radius:50% 50% 50% 0;
      transform:rotate(-45deg);box-shadow:${sh};display:flex;align-items:center;justify-content:center;margin-top:4px;">
      <svg width="14" height="14" viewBox="0 0 24 24" style="transform:rotate(45deg)" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="2.5"/>
      </svg>
    </div>`,
    size: [38, 42],
    anchor: [19, 38],
    popup: [0, -34],
  };
}

/** Tròn + glyph SVG bên trong */
function roundGlyph(bg, svgStroke, svgPaths, B, S, size = 42) {
  const sh = shadow(S);
  return {
    html: `
    <div style="width:${size}px;height:${size}px;border-radius:50%;background:${bg};
      border:${B}px solid #fff;box-shadow:${sh};display:flex;align-items:center;justify-content:center;">
      <svg width="${Math.round(size * 0.52)}" height="${Math.round(size * 0.52)}" viewBox="0 0 24 24" fill="none" stroke="${svgStroke}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${svgPaths}</svg>
    </div>`,
    size: [size, size],
    anchor: [size / 2, size - 4],
    popup: [0, -(size - 6)],
  };
}

/** Viên ngang bo góc */
function pillGlyph(bg, svgPaths, B, S, w = 46, h = 34) {
  const sh = shadow(S);
  return {
    html: `
    <div style="width:${w}px;height:${h}px;border-radius:11px;background:${bg};
      border:${B}px solid #fff;box-shadow:${sh};display:flex;align-items:center;justify-content:center;">
      <svg width="${w - 18}" height="${h - 8}" viewBox="0 0 24 20" fill="none" stroke="#fff" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">${svgPaths}</svg>
    </div>`,
    size: [w, h],
    anchor: [w / 2, h - 2],
    popup: [0, -(h - 4)],
  };
}

/** Kim cương (xoay ô vuông) */
function diamondGlyph(bg, inner, B, S) {
  const sh = shadow(S);
  return {
    html: `
    <div style="width:40px;height:40px;display:flex;align-items:center;justify-content:center;">
      <div style="width:34px;height:34px;background:${bg};border:${B}px solid #fff;border-radius:8px;
        transform:rotate(45deg);box-shadow:${sh};display:flex;align-items:center;justify-content:center;">
        <div style="transform:rotate(-45deg);color:#fff;display:flex;">${inner}</div>
      </div>
    </div>`,
    size: [40, 40],
    anchor: [20, 36],
    popup: [0, -32],
  };
}

function buildSpec(visual, tileStyle) {
  const B = bw(tileStyle);
  const S = tileStyle;

  switch (visual) {
    case "culture":
      return specCulture(B, S);
    case "food":
      return specFood(B, S);
    case "stay":
      return specStay(B, S);
    case "church":
      return roundGlyph(
        "linear-gradient(145deg,#8b5cf6,#5b21b6)",
        "#fff",
        '<path d="M12 3l8 5v14H4V8l8-5z"/><path d="M12 8v13"/><path d="M9 12h6"/>',
        B, S, 44
      );
    case "temple":
      return pillGlyph(
        "linear-gradient(180deg,#fbbf24,#d97706)",
        '<path d="M4 16h16"/><path d="M6 16V9l6-4 6 4v7"/><path d="M9 9h6"/><path d="M12 5V3"/>',
        B, S, 44, 36
      );
    case "flower":
      return roundGlyph(
        "linear-gradient(145deg,#4ade80,#15803d)",
        "#fff",
        '<circle cx="12" cy="12" r="3"/><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>',
        B, S, 44
      );
    case "coffee":
      return pillGlyph(
        "linear-gradient(180deg,#92400e,#451a03)",
        '<path d="M18 8h1a4 4 0 0 1 0 8h-1"/><path d="M2 8h12v5a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"/><line x1="6" y1="2" x2="6" y2="4"/><line x1="10" y1="2" x2="10" y2="4"/>',
        B, S, 42, 34
      );
    case "market":
      return diamondGlyph(
        "#ea580c",
        `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/>
        </svg>`,
        B, S
      );
    case "lake":
      return roundGlyph(
        "linear-gradient(145deg,#38bdf8,#0369a1)",
        "#fff",
        '<path d="M2 12c2-2 5-2 7 0s5 2 7 0 5-2 7 0"/><path d="M2 17c2-2 5-2 7 0s5 2 7 0 5-2 7 0"/>',
        B, S, 44
      );
    case "park":
      return roundGlyph(
        "linear-gradient(145deg,#86efac,#166534)",
        "#fff",
        '<path d="M12 22v-7"/><path d="M9 8a3 3 0 0 1 6 0c0 3-3 5-3 5s-3-2-3-5z"/>',
        B, S, 44
      );
    case "hotel":
      return pillGlyph(
        "linear-gradient(180deg,#fcd34d,#b45309)",
        '<path d="M3 21h18"/><path d="M5 21V7l7-4 7 4v14"/><path d="M9 21v-4h6v4"/><path d="M9 11h2"/><path d="M13 11h2"/>',
        B, S, 48, 36
      );
    case "viewpoint": {
      const D = drop(S, true);
      return {
        html: `
        <div style="width:38px;height:46px;pointer-events:none;filter:${D};">
          <svg width="38" height="46" viewBox="0 0 38 46" style="display:block;">
            <path fill="#dc2626" stroke="#fff" stroke-width="${B}"
              d="M19 2C11 2 5 8.2 5 15.5c0 5.5 4 11 14 27.5 10-16.5 14-22 14-27.5C33 8.2 27 2 19 2z"/>
            <g fill="none" stroke="#fef2f2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" transform="translate(8,9)">
              <path d="M11 14L6 18h10l-5-4z"/><path d="M6 18v4h10v-4"/>
            </g>
          </svg>
        </div>`,
        size: [38, 46],
        anchor: [19, 46],
        popup: [0, -44],
      };
    }
    case "farm":
      return pillGlyph(
        "linear-gradient(180deg,#d97706,#78350f)",
        '<path d="M3 21V10l9-5 9 5v11"/><path d="M9 21v-6h6v6"/><path d="M3 14h18"/>',
        B, S, 46, 36
      );
    case "night": {
      const sh = shadow(S);
      const size = 44;
      return {
        html: `
        <div style="width:${size}px;height:${size}px;border-radius:50%;background:linear-gradient(145deg,#6366f1,#312e81);
          border:${B}px solid #fff;box-shadow:${sh};display:flex;align-items:center;justify-content:center;">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="#fde68a" stroke="#fde68a" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">
            <path fill="#fde68a" stroke="none" d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
            <path fill="none" stroke="#fef3c7" stroke-width="1.5" d="M16.5 6.5l.5-2 1 2 2 .5-2 .5-1 2-.5-2-2-.5 2-.5z" opacity="0.9"/>
          </svg>
        </div>`,
        size: [size, size],
        anchor: [size / 2, size - 4],
        popup: [0, -(size - 6)],
      };
    }
    case "camera":
      return roundGlyph(
        "linear-gradient(145deg,#f472b6,#9d174d)",
        "#fff",
        '<path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"/><circle cx="12" cy="13" r="3"/>',
        B, S, 44
      );
    case "museum":
      return {
        html: `
        <div style="width:42px;height:40px;border-radius:10px;background:linear-gradient(180deg,#14b8a6,#0f766e);
          border:${B}px solid #fff;box-shadow:${shadow(S)};display:flex;align-items:center;justify-content:center;">
          <svg width="24" height="22" viewBox="0 0 24 22" fill="none" stroke="#ecfeff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 20h18"/><path d="M4 20V8l8-5 8 5v12"/><path d="M9 20v-6h6v6"/><path d="M9 8h6"/>
          </svg>
        </div>`,
        size: [42, 40],
        anchor: [21, 36],
        popup: [0, -32],
      };
    case "bridge":
      return pillGlyph(
        "linear-gradient(180deg,#64748b,#334155)",
        '<path d="M4 18h16"/><path d="M6 18v-4a6 6 0 0 1 12 0v4"/><path d="M8 14v4M12 12v6M16 14v4"/>',
        B, S, 46, 34
      );
    case "camping":
      return diamondGlyph(
        "#365314",
        `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ecfccb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 20h16"/><path d="M6 20L12 6l6 14"/><path d="M9 20h6"/>
        </svg>`,
        B, S
      );
    default:
      return specDefault(B, S);
  }
}

const iconCache = new Map();

export function getCachedLocationIcon(mapIcon, category, categorySlug, tileStyle) {
  // Custom uploaded icon URL (PNG/SVG/WebP...) has priority
  const customUrl =
    typeof mapIcon === "object" && mapIcon && mapIcon.customUrl
      ? String(mapIcon.customUrl).trim()
      : "";
  if (customUrl) {
    const key = `custom|${customUrl}`;
    if (!iconCache.has(key)) {
      iconCache.set(
        key,
        L.icon({
          iconUrl: customUrl,
          iconSize: [44, 44],
          iconAnchor: [22, 40],
          popupAnchor: [0, -34],
        })
      );
    }
    return iconCache.get(key);
  }

  const visual =
    typeof mapIcon === "object" && mapIcon && "mapIcon" in mapIcon
      ? resolveMarkerVisualKey(mapIcon.mapIcon, category, categorySlug)
      : resolveMarkerVisualKey(mapIcon, category, categorySlug);
  const key = `${visual}|${tileStyle}`;
  if (!iconCache.has(key)) {
    const spec = buildSpec(visual, tileStyle);
    iconCache.set(
      key,
      L.divIcon({
        html: spec.html,
        className: "custom-map-icon",
        iconSize: spec.size,
        iconAnchor: spec.anchor,
        popupAnchor: spec.popup,
      })
    );
  }
  return iconCache.get(key);
}

/** Dùng trong admin: preview HTML của marker (không cần Leaflet instance). */
export function getMarkerPreviewSpec(mapIcon, category, categorySlug, tileStyle = "color") {
  const visual = resolveMarkerVisualKey(mapIcon, category, categorySlug);
  return buildSpec(visual, tileStyle);
}
